import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { Button } from '../../Button/Button.js';
import '../../Button/ButtonBase/index.js';
import '../../Button/ButtonBody/index.js';

var PaginationButton = forwardRef(function PaginationButton(_a, ref) {
    var _b = _a.themeKey, themeKey = _b === void 0 ? "paginationButton" : _b, sx = _a.sx, props = __rest(_a, ["themeKey", "sx"]);
    return (jsx(Button, __assign({ ref: ref, type: "button", themeKey: themeKey }, __assign({ sx: sx }, props))));
});

export { PaginationButton };
//# sourceMappingURL=PaginationButton.js.map
